import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["expiresInHours", "expires"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import clientSetCookie from './clientSetCookie';
var clientSetCookieThatExpiresInHours = function clientSetCookieThatExpiresInHours(name, value) {
  var extendedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var expiresInHours = extendedOptions.expiresInHours,
    expires = extendedOptions.expires,
    restOfOptions = _objectWithoutProperties(extendedOptions, _excluded);
  var computedExpires = !!expiresInHours && Math.max(0, expiresInHours) ? new Date(Date.now() + expiresInHours * 60 * 60 * 1000) : expires;
  clientSetCookie(name, value, _objectSpread({
    expires: computedExpires
  }, restOfOptions));
};
export default clientSetCookieThatExpiresInHours;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/clientSetCookieThatExpiresInHours.js
// module id = 2626
// module chunks = 11